<template>
  <div style="display: none">
    <img :src="require('@/assets/zsplus.jpg')" />
  </div>
  <div class="top-navigator" v-if="!iszsrbapp">
    <div class="top-navigator-left">
      <img class="logo" :src="require('@/assets/zsplus.png')" />
      <!-- <div class="line"></div> -->
      <!-- <div class="channel" v-if="categoryList && categoryList.length > 0">
        {{ categoryList[0].name + "频道" }}
      </div> -->
    </div>
    <wx-open-launch-app
      class="top-navigator-right"
      id="launch-btn"
      appid="wxc9da92efaf026389"
      :extinfo="dataModal.exinfo"
      @launch="handleLaunch"
      @error="handleError"
    >
      <div v-is="'script'" type="text/wxtag-template">
        <button
          style="
            color: red;
            font-size: 12px;
            background-color: white;
            float: right;
            border: 1px solid red;
            border-radius: 12.5px;
            margin-top: 0.1rem;
            width: 80px;
            height: 25px;
            margin-right: 10px;
          "
          class="btn"
        >
          打开APP
        </button>
      </div>
    </wx-open-launch-app>
  </div>
  <div class="content-list" :style="!iszsrbapp ? 'padding-top: 10vw;' : ''">
    <div>
      <NewsList class="content" />
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import NewsList from "../components/NewsList.vue";

export default {
  name: "Home",
  components: {
    NewsList,
  },
  setup() {
    const store = useStore();
    const u = navigator.userAgent;
    onMounted(() => {
      // store.dispatch("getCategory").then(() => {});
      //友盟曝光元素
      // const { aplus_queue } = window;
      // aplus_queue.push({
      //   action: "aplus.record",
      //   arguments: [
      //     "$$_exposure",
      //     "EXP",
      //     {
      //       //key为字符串类型, value为字符串或Number类型，长度均限制在128位字符以内
      //       type: "topicNews",
      //       newsId: store.state.dataModal.title,
      //       link: window.location.href,
      //       userAgent: u.toLowerCase(),
      //       publishTime: store.state.dataModal.publishTime,
      //     },
      //   ],
      // });
    });
    const handleLaunch = (e) => {
      console.log(e);
      window.open(store.state.dataModal.apkLink);
    };

    const handleError = (e) => {
      console.log(e.detail);
      const userAgentString = u.toLowerCase();
      if (
        userAgentString.indexOf("iphone") >= 0 ||
        userAgentString.indexOf("ipad") >= 0
      ) {
        window.open(
          "https://itunes.apple.com/cn/app/zsrb/id1000536971",
          "_blank"
        );
      } else if (userAgentString.indexOf("android") >= 0) {
        window.open(
          "https://sj.qq.com/myapp/detail.htm?apkName=com.zszs.activity",
          "_blank"
        );
      }
    };

    return {
      handleError,
      handleLaunch,
      loading: computed(() => {
        return store.state.dataModal > 0;
      }),
      dataModal: computed(() => store.state.dataModal),
      iszsrbapp: u.toLowerCase().indexOf("zsrbapp") >= 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.content-list {
  width: 100vw;
  // padding-top: 10vw;
}
// .top-navigator {
//   // z-index: 100;
//   // position: fixed;
//   width: 100%;
//   height: 10vw;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// }
.top-navigator {
  z-index: 100;
  position: fixed;
  width: 100%;
  // height: 50px;
  height: 10vw;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-navigator-right {
    width: 30vw;
    margin-right: 2vw;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .top-navigator-left {
    height: 100%;
    display: flex;
    align-items: center;
    .logo {
      height: 100%;
      width: auto;
    }
    .line {
      margin-left: 12px;
      height: 50%;
      width: 1px;
      background-color: white;
    }
    .channel {
      margin-left: 12px;
      color: white;
      font-size: 4.53vw;
      font-weight: 800;
    }
  }
}
</style>
